<script>
import * as PIXI from 'pixi.js';
import { mapGetters } from 'vuex';
import utils from '@/utils';
import config from '@/config';
import TweenMax, { Power3, Linear } from 'gsap/TweenMax';

export default {
  name: 'PixiSmog',
  data() {
    return {
      app: null,

      screenReference: null,

      //interval
      percentInterval: null,
      tipsInterval: null,
      frotteInterval: null,
      
      //containers
      brush: null,
      bgContainer: null,
      carContainer: null,
      renderTexture: null,
      whiteGraphic: null,

      animations: {},

      //flags
      isDrawing: false,
      hasMoved: false,

      percent: 0,
    }
  },
  computed: {
    ...mapGetters({
      viewport: 'App/viewport',
      isTablet: 'App/isTablet',
      showTips: 'Interface/showTips',
    }),
    stage() {
      return this.app.stage;
    },
    headerHeight() {
      return 46;
    },
    resizeScale() {
      return {
        x: this.viewport.width / this.screenReference.width,
        y: this.viewport.height / this.screenReference.height
      };
    }
  },
  mounted() {
    if(this.app) return;

    this.app = new PIXI.Application({
      width: this.viewport.width, height: this.viewport.height - this.headerHeight,
      backgroundColor: 0x000000,
      resolution: 1,
      view: document.querySelector('.pixi-stage'),
      transparent: true,
    });

    this.$nextTick( () => {
      this.init();
      
      this.screenReference = {width: 1080, height: 1920};
      
      this.resize(this.viewport.width, this.viewport.height);
    });
  },
  beforeDestroy() {
    this.stopTipsTimer();
    this.stopFrotteInterval();
    
    if(this.stage) {
      this.stage.removeChildren();
      this.stage.off();
    }

    if(this.app) {
      this.app.destroy();
      this.app = null;
    }
  },
  methods: {
    init() {
      this.bgContainer = new PIXI.Sprite();
      this.stage.addChild(this.bgContainer);

      //background
      const bg = new PIXI.Sprite(this.$store.getters['Textures/byId']('backgroundTB2').texture);
      bg.name = "background";
      this.bgContainer.addChild(bg);

      //arbre
      const tree = new PIXI.Sprite(this.$store.getters['Textures/byId']('arbreTB2').texture);
      tree.name = "treeMask";
      this.bgContainer.addChild(tree);

      this.addCars();

      this.carContainer.mask = tree;
      
      //pollution
      const pollution = new PIXI.Sprite(this.$store.getters['Textures/byId']('pollutionTB2').texture);
      pollution.name = "pollution";
      this.stage.addChild(pollution);

      //---- render texure
      this.renderTexture = PIXI.RenderTexture.create(this.viewport.width, this.viewport.height);

      const rdSprite = new PIXI.Sprite(this.renderTexture);
      rdSprite.name = "rdSprite";
      this.stage.addChild(rdSprite);

      this.whiteGraphic = new PIXI.Graphics();
      this.whiteGraphic.beginFill(0xFFFFFF);
      this.whiteGraphic.drawRect(0, 0, this.viewport.width, this.viewport.height);
      this.whiteGraphic.endFill();
      this.app.renderer.render(this.whiteGraphic, this.renderTexture, false, null, false);

      pollution.mask = rdSprite;

      //-----1 seconds to know the percent
      this.percentInterval = setInterval(this.checkDrawing.bind(this), 1000);

      // //Arrivée pollution
      TweenMax.from(pollution, 4, {alpha:0, ease:Power3.easeOut, delay: 5, onCompleteScope: this, onComplete: () => {
        this.startDrawing();
      }});
    },

    addCars() {
      //car container
      this.carContainer = new PIXI.Sprite();
      this.stage.addChild(this.carContainer);

      const auto1Textures = [
        this.$store.getters['Textures/byId']('spsheet-auto1').spritesheet.textures['auto11.png'],
        this.$store.getters['Textures/byId']('spsheet-auto1').spritesheet.textures['auto12.png'],
        this.$store.getters['Textures/byId']('spsheet-auto1').spritesheet.textures['auto13.png'],
      ];

      const auto1Sprite = new PIXI.AnimatedSprite(auto1Textures);
      auto1Sprite.name = "auto1";
      auto1Sprite.loop = true;
      auto1Sprite.anchor.set(.5, .5);
      auto1Sprite.animationSpeed = .15;
      auto1Sprite.play();
      this.carContainer.addChild(auto1Sprite);

      //voiture 2
      const auto2Textures = [
        this.$store.getters['Textures/byId']('spsheet-auto2').spritesheet.textures['auto21.png'],
        this.$store.getters['Textures/byId']('spsheet-auto2').spritesheet.textures['auto22.png'],
        this.$store.getters['Textures/byId']('spsheet-auto2').spritesheet.textures['auto23.png'],
      ];

      const auto2Sprite = new PIXI.AnimatedSprite(auto2Textures);
      auto2Sprite.name = "auto2";
      auto2Sprite.loop = true;
      auto2Sprite.animationSpeed = .15;
      auto2Sprite.play();
      auto2Sprite.scale.set(0.3); 
      auto2Sprite.anchor.set(0.5);
      auto2Sprite.zIndex = 2;
      this.carContainer.addChild(auto2Sprite);

      //voiture 3
      const auto3Textures = [
        this.$store.getters['Textures/byId']('spsheet-auto3').spritesheet.textures['auto31.png'],
        this.$store.getters['Textures/byId']('spsheet-auto3').spritesheet.textures['auto32.png'],
        this.$store.getters['Textures/byId']('spsheet-auto3').spritesheet.textures['auto33.png'],
      ];

      const auto3Sprite = new PIXI.AnimatedSprite(auto3Textures);
      auto3Sprite.name = "auto3";
      auto3Sprite.loop = true;
      auto3Sprite.anchor.set(0.5);
      auto3Sprite.animationSpeed = .15;
      auto3Sprite.play();
      auto3Sprite.scale.set(0.3);
      auto3Sprite.zIndex = 2;
      this.carContainer.addChild(auto3Sprite);
    },

    startDrawing() {
      
      //brush
      this.brush = PIXI.Sprite.from('/assets/tableaux/smog/brush.png');
      this.brush.anchor.set(.5);
      this.brush.scale.set( this.isTablet ? .5 : .25);

      this.stage.interactive = true;
      this.stage.on('pointerdown', this.down);
      this.stage.on('pointerup', this.up);
      this.stage.on('pointermove', this.move);

      this.stopTipsTimer();
      this.startTipsTimer();
    },

    stopDrawing() {
      clearInterval(this.percentInterval);
      
      this.stopTipsTimer();
      this.stopFrotteInterval();

      this.stage.interactive = false;
      this.stage.off();

      this.$emit('leave');
    },

    startTipsTimer() {
      this.tipsInterval = setInterval(() => {
        this.$store.dispatch('Interface/SHOW_TIPS');
      }, 5000);
    },

    stopTipsTimer() {
      clearInterval(this.tipsInterval);
      if(this.showTips) this.$store.dispatch('Interface/HIDE_TIPS');
    },

    startFrotteInterval() {
      this.frotteInterval = setTimeout(() => {
        this.hasMoved = false;
      }, utils.randomBetween(400, 800));
    },

    stopFrotteInterval() {
      clearTimeout(this.frotteInterval);
    },

    down(event) {
      this.isDrawing = true;
      this.move(event)
      this.stopTipsTimer();
    },

    up() {
      this.isDrawing = false;
      this.stopTipsTimer();
      this.startTipsTimer();
    },

    move(event) {
      if(!this.isDrawing) return;

      this.brush.position.copyFrom(event.data.global);
      this.app.renderer.render(this.brush, this.renderTexture, false, null, false);

      // son doigt
      if(!this.hasMoved){
        this.hasMoved = true;
        this.$store.dispatch('Sound/PLAY', {id: Math.random() > .5 ? 'smog-frotte1' : 'smog-frotte2', rate: Math.random() * 1 + 0.5})

        this.startFrotteInterval();
      }
    },

    checkDrawing() {
      this.getDrawingPercent();

      if(this.percent >= config.SETTINGS.Smog.reach) {
        this.stopDrawing();
      }
    },

    getDrawingPercent() {
      if(!this.app) return;

      const pixels = this.app.renderer.extract.pixels(this.renderTexture);
      const size = pixels.length;
      const width = this.renderTexture.baseTexture.width;
      const height = this.renderTexture.baseTexture.height;

      let counter = 0;

      for(let i = 0; i < size; i += 4) {
        if (pixels[i] === 0 && pixels[i+1] === 0 && pixels[i+2] === 0 && pixels[i+3] === 255) {
          counter += 3;
        }
      }

      this.percent = Math.ceil((counter / (width * height)) * 100);
    },

    resize(w, h) {
      this.app.renderer.resize(w, h - this.headerHeight);
      
      const bgContainerIds = [{id:'background', keepRatio:true, toTop:false}, {id:'treeMask', keepRatio:true, toTop:false}];
      bgContainerIds.forEach( asset => {
        utils.toFullscreen(this.bgContainer.getChildByName(asset.id), {w, h, keepRatio: asset.keepRatio, toTop: asset.toTop});
      });

      const stageIds = [{id:'pollution', keep:false}, {id:'rdSprite', keepRatio:false}];
      stageIds.forEach( asset => {
        utils.toFullscreen(this.stage.getChildByName(asset.id), {w, h, keepRatio: asset.keepRatio});
      });
      
      const carIds = [{id:'auto1', keep:true, offset: {x:.1, y:.15}}, {id:'auto2', keep:true, offset: {x:.1, y:.08}}, {id:'auto3', keep:true, offset: {x:.1, y:.09}}];
      carIds.forEach( asset => {
        utils.centerAssetToScreen(this.carContainer.getChildByName(asset.id), {w, h, offset:asset.offset, scale: this.resizeScale, keepRatio: asset.keepRatio});
      });

      //------
      const auto1 = this.carContainer.getChildByName('auto1');
      TweenMax.killTweensOf(auto1);
    
      this.animations.car1 = TweenMax.fromTo(auto1, 4, {x:-100, y:(this.isTablet) ? "+=55" : "+=28"}, {x:w + 100, y:(this.isTablet) ? "-=135" : "-=85", ease: Linear.easeNone, delay: 0.3, repeat:-1});
      this.animations.car1.play();

      const auto2 = this.carContainer.getChildByName('auto2');
      TweenMax.killTweensOf(auto2);
      
      this.animations.car2 = TweenMax.fromTo(auto2, 4, {x:-100, y:(this.isTablet) ? "+=55" : "+=28"}, {x:w + 100, y:(this.isTablet) ? "-=135" : "-=85", ease: Linear.easeNone, delay: 1.5, repeat:-1});
      this.animations.car2.play();

      const auto3 = this.carContainer.getChildByName('auto3');
      TweenMax.killTweensOf(auto3);
      
      this.animations.car3 = TweenMax.fromTo(auto3, 4, {x:-100, y:(this.isTablet) ? "+=55" : "+=28"}, {x:w + 100, y:(this.isTablet) ? "-=135" : "-=85", ease: Linear.easeNone, delay: 3, repeat:-1});
      this.animations.car3.play();
    },
  }
}
</script>

<template>
  <canvas ref='Canvas' :width="viewport.width" :height="viewport.height - headerHeight" class='pixi-stage' />
</template>

<style scoped lang="scss">
.pixi-stage {
  // width: 100%;
  // height: 100%;
  position: relative;
  top: 0;
  left: 0px;
}
</style>
